import React from "react";
import styled from "styled-components";
import Icon from '@material-ui/core/Icon'

const Container = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin: 32px 0px;
  max-width: 600px;
  width: 100%;
  @media (max-width: 900px) {
    margin: 12px 0px;
  }
  h6 {
    font-size: 1rem;
		letter-spacing: 0px;
    padding-right: 18px;
    @media (max-width: 900px) {
      font-size: .9rem;
    }
  }
`;

const ToggleContainer = styled.div`
  cursor: pointer;
  position: relative;
`;

const ToggleBackground = styled.div`
  background: ${(props) =>
    props.checked ? "linear-gradient(#00ec46, #0e9e38)" : "#d7dde8"};
  box-shadow: ${(props) => (props.checked ? "0px 0px 8px #00ee46;" : "none")};
  border-radius: 100px;
  // background: linear-gradient(#00ec46, #0e9e38);
  // box-shadow: 0px 0px 8px #00ee46;
  height: 28px;
  width: 51px;
  transition: 0.2s ease all;
`;

const ToggleThumb = styled.div`
    background: #FFF;
    border-radius: 100px;
    height: 24px;
    width: 24px;
    position: absolute;
    top: 50%;
    left: ${(props) => (props.checked ? "calc(100% - 27px)" : "3px")};
    // left: ${(props) => (props.checked ? "unset" : "4px")};
    // right: ${(props) => (props.checked ? "2px" : "unset")};
    transform: translateY(-50%);
    transition: 0.2s ease all;
`;

const Wrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;

  span {
    cursor: pointer;
  }
`;

export const Toggle = (props) => {
  return (
    <Container>
      <Wrapper>
        {props.info && <Icon onClick={() => props.onInfoClick()}>help_outline</Icon>}
        <h6>{props.label}</h6>
      </Wrapper>
      <ToggleContainer onClick={() => props.onChange(props.value)}>
        <ToggleBackground checked={props.checked} />
        <ToggleThumb checked={props.checked} />
      </ToggleContainer>
    </Container>
  );
};

export const ToggleButton = (props) => {
  return (
    <ToggleContainer onClick={() => props.onChange(props.value)}>
      <ToggleBackground checked={props.checked} />
      <ToggleThumb checked={props.checked} />
    </ToggleContainer>
  );
};
